import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import { PostDataFragmentDoc } from '../../../../../fragments/__generated__/postData.generated';
import { UserBasicInfoFragmentDoc } from '../../../../communities/components/GroupMembersList/__generated__/user.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PostsToReviewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PostsToReviewQuery = { __typename?: 'Query', postsToReview: Array<{ __typename?: 'Post', publishAt?: number | null, id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, review?: { __typename?: 'PostReview', uuid: string, status: Types.PostReviewStatus, feedback?: string | null } | null, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null }> };

export type PostWithReviewFragment = { __typename?: 'Post', publishAt?: number | null, id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, review?: { __typename?: 'PostReview', uuid: string, status: Types.PostReviewStatus, feedback?: string | null } | null, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null };

export const PostWithReviewFragmentDoc = gql`
    fragment PostWithReview on Post {
  ...PostData
  review {
    uuid
    status
    feedback
  }
  selectedUsers {
    user {
      ...UserBasicInfo
    }
  }
  publishAt
}
    ${PostDataFragmentDoc}
${UserBasicInfoFragmentDoc}`;
export const PostsToReviewDocument = gql`
    query PostsToReview {
  postsToReview {
    ...PostWithReview
  }
}
    ${PostWithReviewFragmentDoc}`;

/**
 * __usePostsToReviewQuery__
 *
 * To run a query within a React component, call `usePostsToReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsToReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsToReviewQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostsToReviewQuery(baseOptions?: Apollo.QueryHookOptions<PostsToReviewQuery, PostsToReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsToReviewQuery, PostsToReviewQueryVariables>(PostsToReviewDocument, options);
      }
export function usePostsToReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsToReviewQuery, PostsToReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsToReviewQuery, PostsToReviewQueryVariables>(PostsToReviewDocument, options);
        }
// @ts-ignore
export function usePostsToReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostsToReviewQuery, PostsToReviewQueryVariables>): Apollo.UseSuspenseQueryResult<PostsToReviewQuery, PostsToReviewQueryVariables>;
export function usePostsToReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsToReviewQuery, PostsToReviewQueryVariables>): Apollo.UseSuspenseQueryResult<PostsToReviewQuery | undefined, PostsToReviewQueryVariables>;
export function usePostsToReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsToReviewQuery, PostsToReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostsToReviewQuery, PostsToReviewQueryVariables>(PostsToReviewDocument, options);
        }
export type PostsToReviewQueryHookResult = ReturnType<typeof usePostsToReviewQuery>;
export type PostsToReviewLazyQueryHookResult = ReturnType<typeof usePostsToReviewLazyQuery>;
export type PostsToReviewSuspenseQueryHookResult = ReturnType<typeof usePostsToReviewSuspenseQuery>;
export type PostsToReviewQueryResult = Apollo.QueryResult<PostsToReviewQuery, PostsToReviewQueryVariables>;